import moment from "moment";

export function greetingByTime(lang = "id") {
  if (lang === "en") return greetingByTimeEN();
  return greetingByTimeID();
}

export function greetingByTimeID() {
  const timeFormat = "HH:mm";
  const currentTime = moment();

  if (currentTime.isBefore(moment("11:00", timeFormat))) return "Selamat Pagi";
  if (currentTime.isBefore(moment("15:01", timeFormat))) return "Selamat Siang";
  if (currentTime.isBefore(moment("18:01", timeFormat))) return "Selamat Sore";
  return "Selamat Malam";
}

export function greetingByTimeEN() {
  const currentTime = moment();
  const currentHour = currentTime.hours();

  if (currentHour < 12) return "Good Morning";
  if (currentHour < 18) return "Good Afternoon";
  return "Good Evening";
}
